export const setSavedData = (keyName, keyValue, ttl) => {
    const data = {
        value: keyValue,                  
        ttl: Date.now() + (ttl * 1000) 
    }
 
    // store data in LocalStorage 
    if (typeof localStorage != 'undefined') {
        localStorage.setItem(keyName, JSON.stringify(data));
    }
};

export const getSavedData = (keyName) => {
    const data = (typeof localStorage != 'undefined') ? localStorage.getItem(keyName) : false;
    if (!data) {     
        return null;
    }
 
    const item = JSON.parse(data);
 
    // If TTL has expired, remove the item from localStorage and return null
    if (Date.now() > item.ttl) {
        localStorage.removeItem(keyName);
        return null;
    }
 
    // return data if not expired
    return item.value;
};